<template>
    <div class="image-container">
      <div v-if="imageLoaded && !imageError" class="loader"></div>
      <img :style="imageStyle" :class="{ 'hidden': imageLoaded }" :src="imageSrc" @load="onImageLoaded" @error="onImageError" :alt="img_alt" />
      <div v-if="imageError" class="error-message">图片加载失败</div>
    </div>
  </template>
  
  <script>
  export default {
    props: ['imageSrc', 'maxHeight', 'altText', 'mywidth', 'myheight'],
    data() {
      return {
        imageLoaded: false,
        imageError: false,
      };
    },
    computed: {
      img_alt() {
        return this.altText || '图片';
      },
      imageStyle() {
        return {
          width: this.mywidth || '100%',
          maxHeight: this.maxHeight,
          height: this.myheight,
        };
      },
    },
    methods: {
      onImageLoaded() {
        this.imageLoaded = true;
      },
      onImageError() {
        this.imageError = true;
      },
    },
  };
  </script>
  
  <style scoped>
  .image-container {
    position: relative;
  }
  
  .loader {
    width: 64px;
    height: 64px;
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    animation: spin 2s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
  
  .hidden {
    display: none;
  }
  
  .error-message {
    color: red;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  </style>
  